import { render, staticRenderFns } from "./readonlyInformation.vue?vue&type=template&id=1bc995f0&scoped=true&"
import script from "./readonlyInformation.vue?vue&type=script&lang=js&"
export * from "./readonlyInformation.vue?vue&type=script&lang=js&"
import style0 from "./readonlyInformation.vue?vue&type=style&index=0&id=1bc995f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc995f0",
  null
  
)

export default component.exports